import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-0"}],["path",{"d":"M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M7 15v-11","key":"svg-2"}],["path",{"d":"M17 15v-11","key":"svg-3"}],["path",{"d":"M3 4h18","key":"svg-4"}]]

const IconRings = createReactComponent('outline', 'rings', 'Rings', __iconNode);

export default IconRings;